import { BranchData } from "src/components/BranchSelector";

export interface CountByStateResult {
  state: RaceState;
  quantity: number;
}

export enum RaceState {
  CREATED = "CREATED",
  ASSIGNED = "ASSIGNED",
  IN_PROGRESS = "IN_PROGRESS",
  DELIVERED = "DELIVERED",
  CANCELLED = "CANCELLED",
}

export type RaceType = "DELIVERY" | "SEND_PACKET" | "TAXI" | "OTHER";

export interface AddRaceDTO {
  type: string;

  observation?: string;
  amount?: number;

  dueDate?: number;

  driver: number | null;

  clientName: string;
  clientDocument: string;
  clientPhone?: string;
  clientAddress?: string;
  clientEmail?: string;

  origin: Location;
  destiny: Location;

  branch?: number | undefined;
}

export interface Race {
  id: number;

  owner: Client;
  driver?: Driver;
  creator: User;

  type: RaceType;
  observation: string;

  startDate: number;
  dueDate?: number;
  endDate?: number;

  assignedDate?: number;
  pickDate?: number;
  branch?: Branch;

  capital?: number;

  route: Route;

  state: RaceState;
}

export interface Route {
  origin: Location;
  destiny: Location;
  mapLine: string;
  length: number;
  price: number;
}

export interface SimpleLocation {
  lat: number;
  lng: number;
}

export interface Location extends SimpleLocation {
  street1: string;
  street2?: string;
  observation?: string;
  number?: number;
  id?: number;
}

export interface User {
  id: number;
  name: string;
  email: string;
  state: "ACTIVE" | "INACTIVE";
}

export interface Client {
  id: string;
  user: User;
  document: string;
  phone?: string;
  address?: string;
}

export interface Driver {
  id: number;
  user: User;
  region: string;
  registryNumber: string;
  registryDate: number | string;
  vehicle: Vehicle;
  branch: BranchData;
}

export type VehicleType = "CAR" | "MOTORCICLE" | "TRUCK";

export interface Vehicle {
  brand: string;
  year: string;
  model: string;
  image: string;
  type: VehicleType;
}

export interface DriverStateDTO {
  id: number;
  name: string;

  raceId: number;
  raceName: string;
  raceState: RaceState;
  raceType: RaceType;

  lat: number;
  lng: number;
  locationDate: number;

  lastRaceId: number;
  lastRaceName: string;

  lastAction: number;

  raceCount: number;
}

export interface Company {
  id: number;
  name: string;
  state: string;
  photo: string;
  priceDelivery: number;
}

export interface Branch {
  name: string;
  company: any;
  state: string;
  location: any;
  id?: number;
}

export interface Category {
  id: number;
  name: string;
  photo: string;
  state?: "ACTIVE" | "INACTIVE";
  position?: number;
}

export interface Product {
  id: number;
  name: string;
  photo: string;
  state?: "ACTIVE" | "INACTIVE";
  price: number;
  category?: Category;
}

export interface DeliveryItemsDTO {
  productId: number;
  quantity: number;
}

export interface AddDeliveryDTO {
  opportunity: AddRaceDTO;
  amount: number;
  priceDelivery: number;
  total: number;
  paymentMethod: string;
  invoice: boolean;
  items: DeliveryItemsDTO[];
}



// WEBPACK FOOTER //
// ./src/api/model.ts